var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUpLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_31_883",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_31_883",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAABQElEQVRoge2awUoCURSGv4KW2XPYg0hujEgQwo29T+Hr+BxGrbKgRasQwo2o2GKGqOsdm7md8RzlfHA2s/jv/3HnzsAw4HxzrF1AghvgA5gC18pdkrkFVsA6n3fdOmmEEmvgVbVRAjGJOdDWLFWVAXGJS81SVXEJK7iEFVzCCrH3hMbMgAfgHjjfV4lwlsAQOCkr0gMWBooXzeiQZIZlRYpkFvn1XXFK9nB5jPRoVgmyIANwBjwFPe6qhliRuQo6jFNCLMg0gvU/U4O6bMosgf7/O5YmPPTJaMuIiYCujKgIFJ+ZjkT4FsRFIC7zLBVeQC0isCkzkQyPUJsIZLfThGw3WtLhAVtFjmpeXJKw/K/uB/HdFlzEHi5iDRexhotYw0Ws4SLWcBFruIg19knk558VL2otBGgDb/lcKHdx/uQLwVA/EK1AcFwAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpLeft);
export default __webpack_public_path__ + "static/media/icon-up-left.cb964ddf92eeb1d74cc3a0b5cdf1f5cd.svg";
export { ForwardRef as ReactComponent };